import React from "react";
const Icon = ({ iconName, className }) => {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/assets/images/${iconName}.svg`}
      alt={iconName}
      className={`c-quiz_icon ${className ? className : ""}`}
    />
  );
};

export default Icon;
